<template>
	<el-menu-item
		v-if="!meta.children || meta.children.length == 0"
		:index="menuPath"
		:key="menuKey"
	>
		<i v-if="meta.icon" :class="meta.icon" class="menu-icon"></i>
		<span>{{meta.name}}</span>
	</el-menu-item>
	<el-submenu v-else :index="menuPath" :key="menuKey">
		<template slot="title">
			<i v-if="meta.icon" :class="meta.icon" class="menu-icon"></i>
			<span>{{meta.name}}</span>
		</template>
		<McMenuItem v-for="(subMenuMeta, index) in meta.children" :meta="subMenuMeta" :path="menuPath" :key="menuPath + subMenuMeta.path + index"/>
	</el-submenu>
</template>


<script>
  export default {
    name: "McMenuItem",
    props: {
			meta: {
				type: Object
			},
			path: {
				type: String,
				default: ''
			}
		},
		computed: {
			menuPath(){
				return this.path + this.meta.path
			},
			menuKey(){
				return this.menuPath + JSON.stringify(this.meta['querys'] || '')
			}
		}
  }
</script>
